import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "#fff"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      d: "M16.7 15.4c0-.7-.6-1.2-1.3-1.2H6.3a4.6 4.6 0 0 1 0-9.2h1.2v1.7H6.3a3 3 0 0 0 0 5.8h9.1a3 3 0 1 1 0 5.8H2.5a.8.8 0 1 1 0-1.6h13c.6 0 1.2-.6 1.2-1.3",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      d: "M14.2 3.3h-3.4c-.9 0-1.6.8-1.6 1.7v1.7c0 .9.7 1.6 1.6 1.6h3.4zm-3.4-1.6A3.3 3.3 0 0 0 7.5 5v1.7C7.5 8.5 9 10 10.8 10H15c.5 0 .8-.4.8-.8V2.5c0-.5-.3-.8-.8-.8z",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", { d: "M17.5 3.3h-1.7V5h1.7a.8.8 0 0 0 0-1.7m0 3.4h-1.7v1.6h1.7a.8.8 0 0 0 0-1.6" }, null, -1)
  ]))]))
}
export default { render: render }